import { motion } from "framer-motion";
import { ROADMAP_STEPS } from "../../data/roadmapData";
import { Zap } from "lucide-react";

export function HowItWorks() {
  return (
    <section
      data-testid="how-it-works-section"
      className="py-16 md:py-20 relative overflow-hidden"
      style={{ background: "linear-gradient(160deg, #0f172a 0%, #1a1035 60%, #0c1a2e 100%)" }}
    >
      {/* Background glows */}
      <div className="absolute top-[8%] left-[4%] w-[420px] h-[420px] rounded-full pointer-events-none" style={{ background: "radial-gradient(circle, rgba(220,38,38,0.07) 0%, transparent 70%)" }} />
      <div className="absolute bottom-[4%] right-[4%] w-[360px] h-[360px] rounded-full pointer-events-none" style={{ background: "radial-gradient(circle, rgba(14,165,233,0.07) 0%, transparent 70%)" }} />

      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16 md:mb-20"
        >
          <span className="text-red-400 font-bold text-xs tracking-[0.2em] uppercase font-body">
            Your Journey With Us
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black text-white mt-3 mb-3 tracking-tight leading-tight">
            Contact to Go Live
            <br />
            <span className="bg-gradient-to-r from-red-500 to-red-400 bg-clip-text text-transparent">
              in Under 1 Day
            </span>
          </h2>
          <p className="text-slate-500 text-base md:text-lg font-body">
            A seamless 5-step process from first call to delivery
          </p>
        </motion.div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 md:gap-4 relative">
          {/* Connector line (desktop) */}
          <div className="hidden md:block absolute top-11 left-[10%] right-[10%] h-0.5 bg-gradient-to-r from-red-600/40 to-cyan-500/30 z-0" />

          {ROADMAP_STEPS.map((step, i) => {
            const Icon = step.icon;
            return (
              <motion.div
                key={step.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="flex flex-col items-center text-center relative z-10"
              >
                <div
                  className="w-20 h-20 md:w-[88px] md:h-[88px] rounded-full flex items-center justify-center mb-5 shadow-xl"
                  style={{
                    background: `linear-gradient(135deg, ${step.color}, ${step.color}cc)`,
                    boxShadow: `0 0 0 8px ${step.color}18, 0 12px 40px ${step.color}35`,
                  }}
                >
                  <Icon size={30} className="text-white" />
                </div>
                <span
                  className="text-[11px] font-extrabold tracking-[0.15em] mb-2 font-body"
                  style={{ color: `${step.color}cc` }}
                >
                  STEP 0{i + 1}
                </span>
                <h3 className="text-base font-extrabold text-white mb-2 font-body">{step.title}</h3>
                <p className="text-[13px] text-slate-500 leading-relaxed font-body max-w-[200px]">
                  {step.desc}
                </p>
                <span
                  className="mt-3 text-xs font-bold px-3 py-1 rounded-full font-body"
                  style={{ background: `${step.color}15`, color: step.color }}
                >
                  {step.tag}
                </span>
              </motion.div>
            );
          })}
        </div>

        {/* Bottom note */}
        <div className="text-center mt-16">
          <div className="inline-flex items-center gap-3 bg-white/[0.04] border border-white/[0.08] rounded-2xl px-8 py-4">
            <Zap size={20} className="text-yellow-400" />
            <p className="text-slate-400 text-sm font-semibold font-body">
              Average onboarding:{" "}
              <span className="text-white font-black">under 1 day</span> — or we expedite at no extra cost.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
